/**
 * Time range mode for tile history viewing
 */
export enum TimeRangeMode {
  Latest = 'latest',
  Custom = 'custom',
}

/**
 * Time range interface for tile history
 */
export interface TimeRange {
  start: number | null; // Unix timestamp in milliseconds
  end: number | null;   // Unix timestamp in milliseconds
  /** PLAT-277: ISO string for start boundary to preserve microsecond precision */
  startIso?: string | null;
  /** PLAT-277: ISO string for end boundary to preserve microsecond precision */
  endIso?: string | null;
}

/**
 * Display labels for time range modes
 */
export const TIME_RANGE_MODE_LABELS: Record<TimeRangeMode, string> = {
  [TimeRangeMode.Latest]: 'Latest',
  [TimeRangeMode.Custom]: 'Custom',
};
